/**
 * Web search tool — delegates to a search-only Gemini model because built-in
 * Google Search cannot be combined with function calling on the planner model.
 */

import { Schema } from "firebase/ai";
import { runWebSearch } from "../model";
import type { PlannerTool } from "./registry";
import { requireString } from "./helpers";

export const searchTools: PlannerTool[] = [
  {
    declaration: {
      name: "search_web",
      description:
        "Search the web for wedding-industry knowledge — vendor pricing benchmarks, traditions, seasonal ideas, etiquette. " +
        "Never for off-topic questions (general recipes, homework, coding, news, sports) or for questions answerable from the couple's own data.",
      parameters: Schema.object({
        properties: {
          query: Schema.string({ description: "The search query." }),
        },
      }),
    },
    destructive: false,
    describe: (args) => {
      const q = typeof args.query === "string" ? args.query.trim() : "";
      return q ? `Wyszukiwanie: ${q.slice(0, 60)}` : "Wyszukiwanie w internecie";
    },
    execute: async (args, ctx) => {
      const query = requireString(args, "query");
      const result = await runWebSearch(query);
      if (result.kind === "refused") {
        return {
          error: "off_topic",
          message: "Query is outside wedding planning scope.",
          instruction:
            "Tell the user this is outside wedding planning scope and do not retry search_web for this question.",
        };
      }
      if (result.kind === "failed") {
        return {
          error: true,
          code: "search_failed",
          message: result.message,
          instruction:
            "Web search failed. Give a helpful ballpark answer from general wedding-planning knowledge for Poland. " +
            "Say you could not verify live prices on the web right now. Do not retry search_web in this turn.",
        };
      }
      ctx.appendSources?.(result.sources);
      return { summary: result.summary, sourceCount: result.sources.length };
    },
  },
];
